export default __webpack_public_path__ + "static/media/50.cdf32549.svg";